import * as React from "react";
import { connect } from "react-redux";
import { AppState } from "../../../redux";
import { PARTNERS } from "./partners";
import { getProfileInfo } from "../../../utilities/get-profile-info";
import { Router } from "../../../utilities/router";

export interface ComponentProps {}

interface MapDispatchProps {}
interface MapStateProps {}

export type Props = ComponentProps & MapDispatchProps & MapStateProps;

export const PartnersLogosComponent = (props: Props) => {
  const goTo = React.useCallback(
    (profileUrl) => (e) => {
      e.preventDefault();
      Router.navigateTo(profileUrl);
    },
    [],
  );
  return (
    <div id="partners-logos" className="team container-fluid">
      <h3>Our Partners</h3>
      <div className="partners-intro">
        <p>
          Radivision is a collaborative platform that partners with the best startup ecosystem leaders and experts to
          help more startups succeed, to share their innovations with the world, and to grow prosperity and quality of
          life for everyone.
        </p>
        <ul>
          {PARTNERS.map((partner) => {
            const { profileUrl } = getProfileInfo(partner);
            return (
              <>
                <a href={profileUrl} className="partners">
                  <img onClick={goTo(profileUrl)} key={partner.id} src={partner.logo} className="partner-logo" />
                </a>
              </>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

const mapState = (state: AppState) => ({});

const mapDispatch = {};

export const PartnersLogos = connect(mapState, mapDispatch)(PartnersLogosComponent);
